import React from "react";
import GUI from "../GUI";

export type TTHProps = React.ComponentPropsWithoutRef<"th">
export type TTableLabel = Record<string,string>|((col:string) => string|JSX.Element)
export type TTHPropper = TTHProps|( (col:string) => TTHProps )
export type TTableSort = {col:string,dir:number}
export type TTableHeadProps = {
    disableSort?:boolean
    sort:TTableSort
    cols:string[]
    sortables?:string[]
    label?:TTableLabel
    htr?:React.ComponentPropsWithoutRef<"tr">
    th?:TTHPropper
    onSort:(sort:TTableSort) => void
}

export default function TableHead(props:TTableHeadProps){
    const headers = props.cols.map(col => {
        const thProps = GUI.getProps(props.th, col)
        const {className,onClick,...th} = thProps
        const noSort = props.sortables && !props.sortables.includes(col)
        const _onClick = (e:React.MouseEvent<HTMLTableCellElement>) => {
            onClick?.(e)
            if (props.disableSort) return
            props.onSort({col,dir:props.sort.col==col ? -props.sort.dir : 1})
        }
        var cell:string|JSX.Element
        if (props.label instanceof Function) cell = props.label(col)
        else if (props.label) cell = props.label[col] || col
        else cell = col

        const arrow = props.disableSort ? <></> : <div className="arrow"/>
        return <th key={col} {...th} className={GUI.joinClass(className, noSort ? "no-sort" : "", props.sort.col==col ? ("sort " + (props.sort.dir<0 ? "dec" : "asc")) : "", )} onClick={_onClick}>
            <div className="th">{cell}{arrow}</div>
        </th>
    })
    return <thead>
        <tr {...props.htr}>
            {headers}
        </tr>
    </thead>
}